export const MaintenanceModeConstants = {
  header: 'MAINTENANCE MODE',
  defaultMsg: 'We\'re just tuning up a few things. This page will be back soon. Thank you!'
};